import { useEffect } from 'react'
import { useAppSelector } from '@/redux/hooks'
import { getOrderParams } from '@/utils/get-order-params'

export function useOrderShortcut() {
  const baseURL = window.location.origin

  const settings = useAppSelector(
    (store) => store.settingsApi.settings.response
  )

  const order = useAppSelector((store) => store.returnsApi.order.response.order)

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if ((event.metaKey || event.ctrlKey) && event.key === 'k') {
        event.preventDefault()

        const params = getOrderParams(
          {
            orderNumber: order?.identification?.customer_printed_order_id ?? '',
            email: order?.customer?.email,
            postalCode: order?.shipping_address?.postcode
          },
          settings.identification_flow!
        )

        const urlToCopy = `${baseURL}/${settings.slug}?${params.toString()}`

        navigator.clipboard.writeText(urlToCopy)
      }
    }

    document.addEventListener('keydown', handleKeyDown)

    return () => {
      document.removeEventListener('keydown', handleKeyDown)
    }
  }, [baseURL, settings, order])
}
